import { useEffect } from 'react'
import { useLocation } from 'react-router'

const ONE_MINUTE = 60_000
const ONE_HOUR = 60 * ONE_MINUTE
const ONE_DAY = 24 * ONE_HOUR
const PREFIX = 'bb-'
// url param to set all billboards state
const ALL_BILLBOARD_PARAM = 'all' // technically its 'bb-all' but we have a namespace helper

function namespaceBillboardKey(name: string) {
  return `${PREFIX}${name}`
}

const isBillboardHidden = (name: string) => {
  const initialIsHidden = window.localStorage.getItem(
    namespaceBillboardKey(name),
  )

  if (!initialIsHidden) {
    return false
  }

  const diff =
    new Date().valueOf() - new Date(Number(initialIsHidden)).valueOf()

  return diff < 30 * ONE_DAY
}

const hideBillboard = (name: string) => {
  window.localStorage.setItem(
    namespaceBillboardKey(name),
    String(new Date().valueOf()),
  )
}

const clearBillboardHidden = (name: string) => {
  window.localStorage.removeItem(namespaceBillboardKey(name))
}

const clearAllBillboardHidden = () => {
  for (const key in localStorage) {
    if (key.startsWith(PREFIX)) {
      localStorage.removeItem(key)
    }
  }
}

const areAllHidden = () => isBillboardHidden(ALL_BILLBOARD_PARAM)

const useBillBoardHiddenState = () => {
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const isAllHidden = params.get(namespaceBillboardKey(ALL_BILLBOARD_PARAM))
    if (isAllHidden || isAllHidden === '') {
      hideBillboard(ALL_BILLBOARD_PARAM)
    } else {
      clearBillboardHidden(ALL_BILLBOARD_PARAM)
    }
  }, [location.search])

  return {
    // fallback to check if all billboards are hidden if specific billboard is not hidden
    isBillboardHidden: (name: string) => {
      return isBillboardHidden(name) ? true : areAllHidden()
    },
    areAllHidden,
    hideBillboard,
    clearBillboardHidden,
    clearAllBillboardHidden,
  }
}

export default useBillBoardHiddenState
